import { Button, Text } from "@itwin/itwinui-react"
import { useAppDispatch } from "store";
import { addSandboxFiles, openFile } from "store/features";
import styles from "./WalkthroughInitializer.module.css";

const filePath = "/walkthrough.md";

export const WalkthroughInitializer = ({ className }: { className?: string }) => {
  const dispatch = useAppDispatch();

  const onCreateWalkthrough = () => {
    dispatch(addSandboxFiles({ filePath, type: "file", content: createWalkthroughStarter() }));
    dispatch(openFile({ filePath }));
  };

  return (
    <div className={[styles.container, className ?? ""].join(" ")}>
      <div className={styles.message}>
        <Text variant="subheading">No walkthrough to display</Text>
        <Text>You can create your own for this sandbox!</Text>
        <Button as="a" className="iui-anchor" styleType="borderless" onClick={onCreateWalkthrough}>Create a walkthrough</Button>
      </div>
    </div>
  )
}

const createWalkthroughStarter = () =>
  `# My first Walkthrough

  This is an example of a walkthrough step. Use steps to iterate through your code by adding \`// START ANNOTATION_TITLE\` and \`// END ANNOTATION_TITLE\` around the sections of code you would like to emphasize.

  In order for the walkthrough iterate over your code, you need to add some metadata to your step. Each metadata property should follow the same basic schema \`[_metadata_:PROPERTY]:- "VALUE"\`, where \`PROPERTY\` is the metadata property and \`VALUE\` is the desired value of that property:

  Below is a list of metadata properties to make your walkthrough more enjoyable:

  - \`annotation\`: string; Corresponds to the ANNOTATION_TITLE in the comments mentioned above. Use property to a step to the code section you would like it to emphasize.
  - \`minor\`: True or false; This property determines if the current step is a minor step that can be skipped over when following the natural flow of the walkthrough.
  - \`index\`: number; This property can accept a number for which you can assign the current step's numbered value.

  # My first minor step

  This is an example of a minor walkthrough step. When following the walkthrough in its natural order, this step can be skipped. However, it is possible to link to this step using the following syntax:

  \`[Click me!](/?step=MINOR_STEP)\`

  An example of this being used will be found on the next step.

  [_metadata_:annotation]:- "MINOR_STEP"
  [_metadata_:minor]:- "true"

  # My first indexed step

  This is an example of an indexed step. Here is a link to the previous minor step: [Click me!](/?step=MINOR_STEP)

  [_metadata_:index]:- "10"
`;